<i18n>
{
  "en": {
    "hello": "Verification System"
  },
  "ja": {
    "hello": "手続きシステム"
  }
}
</i18n>

<template>
  <div>
    <Toolbar :title="campaign.name + $t('hello')" />
    <v-container>
      <v-layout column justify-center style="width: 100%">
        <v-flex style="height: 48px;">
        </v-flex>
        <v-flex xs12 sm10 md5 lg5>
          <v-card style="padding: 32px;">
            <div style="text-align: center; font-size: 3rem; margin: 16px;">
              よくある質問
            </div>
            <ul>
              <li class="qList" v-for="(faqCategory, index) in faqCategoryList" v-bind:key="index"
                ><a :href="'#category' + index">Q.{{ faqCategory.category
              }}</a></li>
            </ul>
          </v-card>

          <template v-for="(faqCategory, categoryIndex) in faqCategoryList">
            <div v-bind:key="categoryIndex">
              <div style="margin-bottom: 20px;">
              &nbsp;
              </div>
              <v-card class="categoryArea">
                <a :id="'category' + categoryIndex"></a>
                <div class="categoryTitle">{{ faqCategory.category }}</div>
                <template v-for="(faq, faqIndex) in faqCategory.faqList">
                  <div v-bind:key="faqIndex" @click="openAnswerList(categoryIndex, faqIndex)">
                    <a :id="'category' + categoryIndex + '-' + faqIndex"></a>
                    <v-card class="qaArea">
                      <v-flex class="question"
                        style="display: flex; justify-content: space-between"
                      >
                        <div><span style="color: red;">Q.</span><span>{{ faq.question }}</span></div>
                        <transition name="expandicon">
                          <v-icon :class="{ expandIcon: faq.isShow }">expand_more</v-icon>
                        </transition>
                      </v-flex>
                        <transition
                          @before-enter="openAnswerBeforeEnter"
                          @enter="openAnswerEnter"
                          @before-leave="openAnswerBeforeLeave"
                          @leave="openAnswerLeave"
                        >
                          <div class="answer" v-if="faq.isShow"><span style="color: blue; font-weight: bold;">A.</span><span v-html="faq.answer"></span></div>
                        </transition>
                    </v-card>
                  </div>
                </template>
              </v-card>
            </div>
          </template>

          <v-card style="padding: 32px; margin-top: 48px;" v-if="campaign.contactUrl">
            <div style="text-align: center; font-size: 2.0rem; margin: 16px;">
              お問い合わせ
            </div>
            <div>
              本キャンペーンのお問い合わせは<a :href="campaign.contactUrl" target=”_blank”>こちら</a>よりお問い合わせください。<br />
              東京カメラ部株式会社「東京カメラ部運営事務局」<br />
              ※都合によりスケジュールは変更させていただく場合がございます。<br />
              ※お問い合わせへのご対応は、3営業日程度（土日祝日を除く）かかることがございますことご容赦ください。<br />
            </div>
          </v-card>

        </v-flex>
        <v-flex style="height: 600px;">
          &nbsp;
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Toolbar from '@/components/molecules/Toolbar.vue';
import { mapGetters, mapActions } from 'vuex';
import { Me, Auth } from '@/api';

export default {
  components: {
    Toolbar
  },
  data() {
    return {
      campaignCode: this.$route.params.campaignCode,
      faqCategoryList: [
        {
          category: 'ログイン',
          faqList: [
            {
              question: '登録用のメールアドレスとパスワードを設定しましたが、メールが届きません。',
              answer: 'メールが届かない場合、迷惑メールフォルダに分類されている可能性もあります。迷惑メールフォルダの中もご確認ください。\n' +
                      'もし迷惑メールフォルダの中にも見当たらない場合は、登録状況を確認いたしますので「登録したメールアドレス」「お名前（Instagramで応募されている場合はご応募時のInstagramユーザーネーム））」をページ下部のお問い合わせフォームからご連絡ください。',
              isShow: false
            },
            {
              question: 'Instagramユーザーネームの認証に失敗します。なぜでしょうか？',
              answer: 'Instagramユーザーネームは、受賞候補となっている作品を投稿したアカウントのユーザーネームのみ使用可能です。その他のアカウントは使用できません。\n' +
              'また、作品投稿時のInstagramユーザーネームから変更されていますと認証に失敗します。その場合、お手数ではございますが、一度事務局へ変更前と変更後のInstagramユーザーネームを記載の上お問い合わせください。\n' +
              '※ユーザーネームの入力において、「＠」マークは不要です',
              isShow: false
            },
            {
              question: 'Instagramユーザーネーム認証画面まで行ったのですが、誤ったメールアドレスで登録しました。別のメールアドレスに変えたいのですがどうしたらいいですか。',
              answer: 'メールでお知らせしたメールアドレス登録画面にて、新しい登録用のメールアドレスとパスワードを設定して手続きシステムアカウントの新規作成いただければ登録情報が上書きされますのでお試しください。もしくは、Instagram認証認証後に、一度登録いただいたアカウントにて手続きシステムへログインいただいた後でも登録メールアドレスの変更が可能です。',
              isShow: false
            },
            {
              question: 'Twitterの認証に失敗します。なぜでしょうか？',
              answer: 'Twitterアカウントは、受賞候補となっている作品を投稿したアカウントのみ使用可能です。その他のアカウントは使用できません。\n' +
              'また、作品投稿時のTwitterユーザーネームから変更されていますと認証に失敗します。その場合、お手数ではございますが、一度事務局へ変更前と変更後のTwitterユーザーネームを記載の上お問い合わせください。',
              isShow: false
            }
          ]
        },
        {
          category: '手続き全般',
          faqList: [
            {
              question: 'ログインしましたが何をすればよいかわかりません。',
              answer: 'ページ上部の「お知らせ」に、必要な手続きを記載しております。また、ページ中央の受賞候補作品に必要な手続きの詳細を記載しておりますので、そちらをご参照ください。',
              isShow: false
            },
            {
              question: '手続きには何があるのでしょうか？流れを教えてください。',
              answer: 'まずは、盗作防止のために受賞候補作品のご本人様確認を行う目的でデータアップロードを行なっていただきます。恐れ入りますがご協力をお願い申し上げます。（その際、高解像度画像データも提出いただきます）\n' +
                      '提出いただいたデータで本人確認が取れた時点で、受賞確定となります。\n' +
                      'またその後、受賞にあたり必要な追加情報の入力を行なっていただきます。\n' +
                      '以上で、手続きは完了となります。\n' +
                      'なお、場合により行わない手続きもあり、必要な手続きは順を追ってページに表示しています。順次ご確認をお願いいたします。',
              isShow: false
            },
            {
              question: 'スマートフォンからアップロードができず、パソコンからログインしたいのですが、ログインURLなどがわからずどうしたら良いかわかりません。',
              answer: 'パソコン上からでも、スマートフォンと同じログインURLより、登録いただいているメールアドレスとパスワードで手続きシステムへのログインが可能です。',
              isShow: false
            },
            {
              question: 'パソコンから手続きシステムにアクセスできません。どうしたら良いでしょう？',
              answer: 'Windowsのパソコンをご使用の場合は、ブラウズを「Internet Explorer」ではなく「Microsoft Edge」でお試しください。（※本手続きシステムは「Internet Explorer」には未対応です）\n' +
                      '推奨される環境は以下となっております。以下のいずれかでお試しください。\n' +
                      '【推奨環境】\n' +
                      '● パソコン\n' +
                      '・macOS：Safari、Chrome、Firefox\n' +
                      '・Windows：Microsoft Edge、Chrome、Firefox\n' +
                      '●スマートフォン\n' +
                      '・iOS：Safari、Chrome\n' +
                      '・Android：Chrome\n' +
                      '※各ブラウザの最新版をご利用ください。',
              isShow: false
            },
            {
              question: '届いたメールに本文がありません。',
              answer: 'まずは、メールアプリを一旦終了し、通信環境が良い状態で再起動をしていただき、本文が表示されるかお試しください。\n' +
                      'それでも改善されない場合は、以下の手順をお試しください。\n' +
                      '（1）DMでお送りした手続きシステムのURLから、再度メールアドレス・パスワードを入力いただき、確認メールを送信してください\n' +
                      '（2）前回とは違うアプリまたはブラウザで確認メールを開いてください',
              isShow: false
            }
          ]
        },
        {
          category: 'データアップロード',
          faqList: [
            {
              question: '画像がアップロードできないのですがどうすればよいでしょう？',
              answer: '対処方法につきましては、\n' +
                      '・ブラウザを変えていただく\n' +
                      '・スマートフォンならパソコンから、パソコンならスマートフォンからご登録いただく\n' +
                      'ことをお試しいただけますと幸いです。\n' +
                      'お手数おかけいたしますが、どうぞ、よろしくお願い申し上げます。',
              isShow: false
            },
            {
              question: 'ZIPでアップロードは可能でしょうか？',
              answer: 'ZIPデータは受け付けておりません。複数のデータを一度でアップロードしたい場合は、1点ずつファイルを選択のうえ、まとめてアップロードいただけますと幸いです。',
              isShow: false
            },
            {
              question: 'データを一部アップロードするのを忘れました。どうすればよいでしょうか？',
              answer: '事務局が確認作業を開始するまでは、データの追加アップロードが可能です。再度アップロードボタンを押し、必要なデータを提出してください。\n' +
                      '※「次のステップまでもうしばらくお待ち下さい。」の文言が表示されている状態では追加アップロードができません。恐れ入りますが事務局の確認作業が終わり次のステップについて連絡があるまでお待ち下さい。',
              isShow: false
            },
            {
              question: '提出期限を過ぎるとどうなりますか？',
              answer: '誠に申し訳ございませんが、期限内にご対応いただけない場合、受賞は見送らせていただきます。何卒ご了承ください。',
              isShow: false
            },
            {
              question: 'クレジットなしの画像データとはなんでしょうか？',
              answer: '画像内にクレジット（お名前やSNSアカウント名などの表示。ウォーターマーク）のないデータとなります。',
              isShow: false
            },
            {
              question: 'ステータスが再度「データ提出待ち」になりました。なぜですか？',
              answer: 'その場合、事務局にて提出いただいたデータの確認を行ったところ、データに不備があった等、何らかのNG理由によりデータの再提出が必要になっている可能性があります。恐れ入りますが、ページ内の受賞候補作品の画像の下に、前回の提出データのNG理由を記載しております。そちらの理由をご参考にして、再度データの提出をお願いします。',
              isShow: false
            },
            {
              question: 'データアップロード中にエラーが発生して上手くいきません。どうしたらよいでしょうか？',
              answer: '無線でネットワークを利用して手続きシステムにアクセスいただいている場合、お近くにある電波を発信する機器や周りの障害物などの影響により、ネットワーク接続が途切れ途切れになっている可能性がございます。その場合は、安定した無線環境を利用する、または有線にてネットワーク接続いただいたうえでのアップロードをお試しください。',
              isShow: false
            },
          ]
        },
        {
          category: '本人確認データ',
          faqList: [
            {
              question: '本人確認データとは何ですか？',
              answer: '盗作防止のため、本人の作品であると証明できる受賞候補作品の「RAWデータ」もしくは「Exif（撮影日時や撮影機種）が保存されている、加工前のオリジナルデータ（カメラで撮ったままの、何のソフトウェアも使用していない画像データ）」のことです。',
              isShow: false
            },
            {
              question: 'データの種類とは何ですか？どのような基準で選択したらよいですか？',
              answer: '本人の作品であることを証明するためのデータの種類のことです。\n' +
                      '以下それぞれの説明ですので、ご確認のうえ、該当する提出データの種類をご選択ください。\n' +
                      '・RAW：編集前のRAWデータとなります。\n' +
                      '・撮って出し：加工前のオリジナルデータ（カメラでJPEG撮影を行ったままの、何のソフトウェアも使用していない画像データ）\n' +
                      '・フィルム：フィルムのネガ/ポジのフレームを残した状態でスキャンした画像データ」または「フィルムのネガ/ポジのフレームまでが写った写真（携帯・スマートフォン等で撮影されたものでも構いません）\n' +
                      '・別カット：受賞候補作品とほぼ同じ作品（対象作品と同じ時に撮影された、似たような別カット）の「RAW」または「撮って出し」データ\n' +
                      '・合成素材：合成を行う前の素材の「RAW」または「撮って出し」データ',
              isShow: false
            },
            {
              question: '受賞候補作品の「RAWデータ」/「加工前のオリジナルデータ（カメラで撮ったままの、何のソフトウェアも使用していない画像データ）」を削除してしまい、提出できません。',
              answer: '募集要項にも記載の通り、盗作防止のためご本人様確認を行う目的で、受賞候補作品のオリジナルデータのご提出は必須とさせていただいております。ご提出いただけない場合、受賞は見送らせていただきますこと、何卒ご了承ください。\n' +
                      '\n' +
                      'なお、削除してしまった作品とほぼ同じ作品（対象作品と同じ時に撮影された、似たような別カット）の「RAWデータ」もしくは「加工前のオリジナルデータ（カメラで撮ったままの、何のソフトウェアも使用していない画像データ）」がある場合は、事務局にて確認・検討させていただきますので、そのデータを一度ご提出ください。\n' +
                      '※その際、データの種類は「別カット」を選択して、その旨がわかるようにコメント等もお願いします。',
              isShow: false
            },
            {
              question: 'フイルムで撮影してスキャンした作品なのですが、本人確認データの提出はどのようにしたらよいでしょうか？',
              answer: '【フィルムのネガ/ポジのフレームを残した状態でスキャンした画像データ】\n' +
                      'もしくは、\n' +
                      '【フィルムのネガ/ポジのフレームまでが写った写真（携帯・スマートフォン等で撮影されたものでも構いません）】\n' +
                      'のどちらかをご提出ください。\n' +
                      '※その際、データの種類は「フィルム」を選択して、その旨がわかるようにコメント等もお願いします。',
              isShow: false
            },
            {
              question: '複数枚ショットによる比較明合成を使っておりますため、「RAWデータ」/「加工前のオリジナルデータ（カメラで撮ったままの、何のソフトウェアも使用していない画像データ）」はかなりの枚数が存在します。 本人確認データはどのような形で提出したらよいでしょうか？',
              answer: '加工前のオリジナルデータのうち、3枚程度で構いませんのでご提出いただけますようお願いいたします。\n' +
                      '※その際、データの種類は「合成素材」を選択して、その旨がわかるようにコメント等もお願いします。',
              isShow: false
            },
          ]
        },
        {
          category: '高解像度データ',
          faqList: [
            {
              question: '高解像度データとは何ですか？',
              answer: 'JPEGもしくはTIFFでの高画質のデータとなります。当フォトコンテスト結果発表ページでのご紹介、写真展の展示などで使用するために提出いただいております。',
              isShow: false
            },
            {
              question: '高解像度データについて、どのくらいのサイズがあれば大丈夫でしょうか？',
              answer: '例えば、展示サイズがA3サイズの場合ですと、長辺4961ピクセル以上を推奨します。\n' +
                      'お持ちの画像データが推奨サイズに満たない方は、可能な限り大きなサイズの画像データにてご提出いただけますようお願いいたします。',
              isShow: false
            },
            {
              question: '高解像度のデータを持っていません。どうすれば良いでしょうか？',
              answer: '事務局にて確認・検討させていただきますので、一度可能な限り大きなサイズの画像データにてご提出いただけますようお願いいたします。',
              isShow: false
            },
          ]
        },
        {
          category: '追加情報',
          faqList: [
            {
              question: '追加情報は何のために入力するのですか？',
              answer: '賞品発送、またはフォトコンテスト結果発表ページでのご紹介、写真展での展示等の際に使用させていただくために入力いただいています。<br />※作品コメントをご入力いただく場合、頭文字のアルファベットのみなど略称を記載することは避けていただきますようお願いいたします。<br />（例：商品名やサービス名、施設名等の固有名詞など）<br />※本コンテストやその関係会社・作品等と関係のない団体・作品の名称などを引用することはお避けください。',
              isShow: false
            },
            {
              question: 'データを提出しましたが次のステップの追加情報の入力ができません。なぜでしょうか？',
              answer: '「追加情報の入力」のステップへは、データの確認が完了し、受賞確定となり次第進んでいただけます。その際には事務局より後日メールをいたしますので、お待ちくださいませ。',
              isShow: false
            },            
            {
              question: '提出期限を過ぎるとどうなりますか？',
              answer: '追加情報の入力を期限内にしていただけなかった場合、作品を展示/掲載する際は情報なしでの展示をさせていただきます。また、賞品発送のある賞の場合、賞品授与は見送りとさせていただくことがあります。予めご了承ください。\n' +
                      '※受賞自体は無効になりません。',
              isShow: false
            },
            {
              question: 'ステータスが再度「追加情報入力待ち」になりました。なぜですか？',
              answer: 'その場合、事務局が入力いただいた情報の確認を行ったところ不備があった等、何らかのNG理由によりデータの再入力が必要になっている可能性があります。恐れ入りますが、ページ内の入力欄の上部にNGの理由を記載しております。そちらの理由を参考に、再度ご入力をお願いいたします。',
              isShow: false
            },
          ]
        },
        {
          category: '賞品',
          faqList: [
            {
              question: '賞品は何になりますか？',
              answer: '賞品に関しましては、各フォトコンテストの募集要項をご参照ください。',
              isShow: false
            },
            {
              question: '受賞した賞には賞品があり、ステータスが「完了」となっているのに賞品が届きません。いつ頃届くのでしょうか？',
              answer: 'ステータスが「完了」となっている場合、すでに賞品の発送は完了していますので、到着まで今しばらくお待ちください。2、3週間経っても到着がない場合、お手数ではございますが、一度事務局へお問い合わせください。',
              isShow: false
            },
          ]
        },
        {
          category: 'ユーザー情報',
          faqList: [
            {
              question: 'メールアドレスを変更したいのですが、可能でしょうか？',
              answer: '上部右のメニューボタンの「ユーザー情報編集」ページより変更できます。',
              isShow: false
            },
            {
              question: 'ログインパスワードを変更したいのですが、可能でしょうか？',
              answer: '上部右のメニューボタンの「ユーザー情報編集」ページより変更できます。',
              isShow: false
            }
          ]
        },
{
          category: '作品確認事項',
          faqList: [
            {
              question: '作品確認事項とはなんですか？',
              answer: '受賞候補品に関してご確認をお願いしたい内容です。',
              isShow: false
            },
            {
              question: '作品確認事項に回答する必要はありますか？',
              answer: 'はい。お手数ですが、質問内容をご確認いただき、ご回答をお願いいたします。',
              isShow: false
            }
          ]
        },
      ]
    }
  },
  computed: {
    ...mapGetters({ campaign: 'getCurrentCampaign' })
  },
  mounted() {
    Auth.prepare({ campaignHash: this.campaignCode })
      .then(result => {
        this.setCurrentCampaign({
          ...result.data.campaign,
          code: this.campaignCode
        });
        //this.temporaryToken = result.result.auth.token;
      })
      .catch(apiError => {
        // この画面でのエラーは意図的にURLを変更されたものなので全部404
        //this.temporaryToken = apiError.data.result.auth.token;
        if (
          apiError.http.statusCode === 400 ||
          apiError.http.statusCode === 401 ||
          apiError.http.statusCode === 403 ||
          apiError.http.statusCode === 404
        ) {
          this.$router.push('/404');
        }
      });
  },

  methods: {
    ...mapActions(['initState', 'resolveCampaignCode', 'login', 'setCurrentCampaign']),
    openAnswerList(categoryIndex, faqIndex) {
      this.faqCategoryList[categoryIndex].faqList[faqIndex].isShow = !this.faqCategoryList[categoryIndex].faqList[faqIndex].isShow;
    },
    openAnswerBeforeEnter(element) {
      element.style.height = '0'; //初期高さ
    },
    openAnswerEnter(element) {
      element.style.height = element.scrollHeight + 'px'; //開ききった時の高さ
    },
    openAnswerBeforeLeave(element) {
      element.style.height = element.scrollHeight + 'px'; //閉じ始めの高さ
    },
    openAnswerLeave(element) {
      element.style.height = '0'; //終了時高さ
    },

  }
};
</script>

<style scoped>

.qList {
  padding: 1px;
}

.categoryArea {
  padding: 16px;
}

.categoryTitle {
  padding: 8px 32px 8px 32px;
  margin-bottom: 16px;
  font-size: 1.5rem;
}

.qaArea {
  padding: 32px 32px 32px 32px; margin: 0px 0px;
  margin: 0px;
  cursor: pointer;
}

.qaArea:hover {
  background-color: #f0ffff;
}

.question {
  margin: 0px 0px 0px 0px;
  font-size: 1.2rem;
}

.answer {
  margin: 16px 0px 0px 0px;
  white-space: pre-wrap;
  overflow: hidden;
}

.v-enter-active,
.v-leave-active {
  /* アニメーションの時間、イージングなどを設定 */
  transition: height 300ms ease-in-out, opacity 300ms ease-in-out;
}

.expandIcon {
	transform: rotate(180deg);
}

.expandicon-enter-active, .expandicon-leave-active {
  transition: transform 300ms;
}

.expandicon-enter, .expandicon-leave-to {
  transform: rotate(180deg);
}

</style>